export default __webpack_public_path__ + "static/media/preme.43ca1e14.svg";